<template>
  <div class="e-paper">
    <div class="e-paper__title flex">
      <img src="@/assets/images/logo_.png" />
      <div class="return_btn">
        <button @click="returnLogin" class="btn_primary">返回</button>
      </div>
    </div>
    <div class="paper_contain">
      <router-view />
    </div>
  </div>
</template>

<style lang="scss">
.e-paper {
  background: #efefef;
  padding: 30px;
  min-height: 100vh;
  text-align: left;
  &__title {
    justify-content: space-between;
    align-items: center;
    .return_btn {
      margin-top: 20px;
      width: 100px;
    }
  }

  .paper_contain {
    margin-top: 20px;
    background: #fff;
    border: 1px solid #ccc;
    padding: 20px 30px;
    text-align: left;
    
    border-radius: 10px;
    .form_input {
      flex-wrap: wrap;
      align-items: flex-start;
      white-space: nowrap;
      .urgent {
        margin-top: 8px;
        span {
          color: #999;
          font-weight: normal;
        }
      }
      .notice_textarea {
        min-height: 50px;
      }
      .multiple_select {
        .el-select {
          width: 100%;
        }
      }
      .time_range {
        align-items: center;
        // justify-content: space-between;
        i.el-icon-caret-right {
          margin: 0 10px;
        }
      }
      label {
        flex: 2;
        font-weight: bold;
        span {
          color: var(--subColor);
        }
      }
      > div {
        flex: 8;

        input,
        textarea {
          width: 100%;
        }
      }
      .special_option {
        max-width: 100%;
        label {
          &.is-checked {
            span {
              color: #409eff;

              font-weight: bold;
            }
          }
        }
        span {
          color: var(--fontGray);
        }
        .el-checkbox-group {
          label {
            display: block;
            font-weight: normal;
          }
        }
      }
      .sing_list {
        margin-top: 20px;
      }
    }
  }
  .close {
    // position: relative;
    top:8vh;
    z-index: 99999;
    left: 50%;
    transform: translateX(270px);
    position: fixed;
    // cursor: pointer;
  }
.commit_btn {
  >button{
    margin:0 10px
  }
  margin-top: 50px;
}
}
</style>
<script>
import mixins from "@/components/mixins.js";
export default {
  name: "new_paper",
  mixins: [mixins],
  methods: {
    returnHome() {
      this.$router.replace({
        path: "/",
      });
    },
  },
};
</script>
